module.exports = __webpack_public_path__ + "static/media/Lexend-Regular.fd2d8ea0.ttf";